import { useNavigate } from "react-router";
import visaImage from "../../../assets/visa-status/visa-image.png";
import { path } from "../../../utils/common/constant";
import { useTranslation } from "react-i18next";

const ViewVisa = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="flex flex-col">
      <div className="w-full py-8 px-4 text-center text-white bg-gradient-to-b from-[#F00D0D] to-[#994F4F]">
        <h1 className="text-[32px] font-bold mb-2">{t("view_visa.title")}</h1>
        <p className="text-[22px] font-bold">
          {t("profile_search.description")}
        </p>
      </div>

      <div className="p-20 flex flex-col justify-center items-center">
        <img src={visaImage} alt="img" />

        <div className="flex w-full justify-center items-center">
          <div className="flex gap-4 mt-8 w-full justify-center items-center text-nowrap">
            <button className="outline-none w-56 py-6 border font-bold border-primary-blue rounded-full text-primary-blue">
              {t("cta.download")}
            </button>

            <button
              className="outline-none w-56 py-6 border font-bold border-transparent rounded-full text-primary-blue bg-primary-lightyellow border-primary-lightyellow"
              onClick={() => {
                navigate("../" + path.HOME);
              }}
            >
              {t("cta.back_to_home")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewVisa;
